import styled from 'styled-components';
import { Image, Button, Gap, Heading } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const SplashElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const DescriptionElement = styled.div`
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
  font-size: 14px;
  margin-top: 10px;
`;

export function NewSftpUserSuccessPage() {
  const { push } = useHistory();
  const { t } = useTranslation('sftpUserManagement');
  return (
    <SplashElement>
      <Image src={'/images/new-user-success-splash.svg'} height={300} />
      <Heading variation="h1">{t('newSftpUser.successPage.heading')}</Heading>
      <DescriptionElement>{t('newSftpUser.successPage.message1')}</DescriptionElement>
      <DescriptionElement>{t('newSftpUser.successPage.message2')}</DescriptionElement>
      <Gap top={40} />
      <Button variation="primary" onClick={() => push('/user-management/sftp-users')}>
        {t('newSftpUser.successPage.button')}
      </Button>
    </SplashElement>
  );
}
